export const GET_USER = "GET_USER"; // get users data for review page
export const AUTH_USER = "AUTH_USER";
export const SELF = "SELF"; // the user who has signed up
export const CLEAR_USER = "CLEAR_USER"; // sign out
